import { render, staticRenderFns } from "./ResultPane.vue?vue&type=template&id=36fb8242&scoped=true&"
import script from "./ResultPane.vue?vue&type=script&lang=js&"
export * from "./ResultPane.vue?vue&type=script&lang=js&"
import style0 from "./ResultPane.vue?vue&type=style&index=0&id=36fb8242&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fb8242",
  null
  
)

export default component.exports